import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SearchSuggestions = () => {
  const [recentSearches, setRecentSearches] = useState([]);
  const [trendingSearches, setTrendingSearches] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Load recent searches from localStorage
    const savedSearches = localStorage.getItem('recentSearches');
    if (savedSearches) {
      setRecentSearches(JSON.parse(savedSearches));
    }

    // Mock trending searches
    const mockTrending = [
      { id: 1, term: "organic apples", count: 1250 },
      { id: 2, term: "fresh milk", count: 980 },
      { id: 3, term: "whole grain bread", count: 875 },
      { id: 4, term: "greek yogurt", count: 720 },
      { id: 5, term: "free range eggs", count: 650 },
      { id: 6, term: "avocados", count: 580 }
    ];
    setTrendingSearches(mockTrending);
  }, []);

  const handleSearchClick = (searchTerm) => {
    // Add to recent searches
    const updatedRecent = [
      searchTerm,
      ...recentSearches.filter(term => term !== searchTerm)
    ].slice(0, 5);
    
    setRecentSearches(updatedRecent);
    localStorage.setItem('recentSearches', JSON.stringify(updatedRecent));
    
    // Navigate to search results
    navigate(`/product-catalog-category-browse?search=${encodeURIComponent(searchTerm)}`);
  };

  const clearRecentSearches = () => {
    setRecentSearches([]);
    localStorage.removeItem('recentSearches');
  };

  return (
    <div className="mb-12">
      <div className="bg-surface rounded-card p-6 shadow-card border border-border-light">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Recent Searches */}
          {recentSearches.length > 0 && (
            <div>
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-body-semibold text-lg text-text-primary flex items-center space-x-2">
                  <Icon name="Clock" size={18} />
                  <span>Recent Searches</span>
                </h3>
                <Button
                  variant="ghost"
                  size="xs"
                  onClick={clearRecentSearches}
                  className="text-text-secondary hover:text-error"
                >
                  Clear
                </Button>
              </div>
              
              <div className="space-y-2">
                {recentSearches.map((search, index) => (
                  <button
                    key={index}
                    onClick={() => handleSearchClick(search)}
                    className="w-full text-left p-2 rounded-input hover:bg-background transition-smooth flex items-center space-x-3 group"
                  >
                    <Icon name="Search" size={14} className="text-text-secondary" />
                    <span className="font-body text-sm text-text-primary group-hover:text-primary">
                      {search}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Trending Searches */}
          <div>
            <h3 className="font-body-semibold text-lg text-text-primary mb-4 flex items-center space-x-2">
              <Icon name="TrendingUp" size={18} />
              <span>Trending Now</span>
            </h3>
            
            <div className="space-y-2">
              {trendingSearches.map((trending) => (
                <button
                  key={trending.id}
                  onClick={() => handleSearchClick(trending.term)}
                  className="w-full text-left p-2 rounded-input hover:bg-background transition-smooth flex items-center justify-between group"
                >
                  <div className="flex items-center space-x-3">
                    <Icon name="Hash" size={14} className="text-text-secondary" />
                    <span className="font-body text-sm text-text-primary group-hover:text-primary">
                      {trending.term}
                    </span>
                  </div>
                  <span className="font-caption text-xs text-text-secondary">
                    {trending.count.toLocaleString()} searches
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Quick Search Categories */}
        <div className="mt-8 pt-6 border-t border-border-light">
          <h3 className="font-body-semibold text-lg text-text-primary mb-4">
            Popular Categories
          </h3>
          
          <div className="flex flex-wrap gap-2">
            {[
              "Organic", "Gluten-Free", "Dairy-Free", "Vegan", 
              "Local", "Fresh", "Frozen", "Snacks"
            ].map((category) => (
              <Link
                key={category}
                to={`/product-catalog-category-browse?filter=${category.toLowerCase()}`}
                className="px-3 py-1 bg-background text-text-secondary rounded-full text-sm hover:bg-primary hover:text-primary-foreground transition-smooth"
              >
                {category}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchSuggestions;